export default __webpack_public_path__ + "static/media/PR_anymedi 1.8d876c72.png";